import { A } from "components/A";
import { BrandLinkButton } from "components/BrandButton";
import { generateNextSeo } from "next-seo/pages";
import Head from "next/head";
import { SiMega } from "react-icons/si";

export default function Sketches() {
  return (
    <div className="container mb-10 max-w-3xl">
      <Head>
        {generateNextSeo({ title: "Sketches" })}
      </Head>

      <h1 className="mt-3 mb-2 text-3xl font-medium">Sketches</h1>

      <div className="max-w-3xl space-y-2">
        <p>
          I do sketches, I usually publish them only on my{" "}
          <A href="https://discord.gg/NsZPUMbvMN">Discord server</A>. However
          they are not easy to find, especially if you are looking for older
          ones.
        </p>

        <p>
          In the past I decided to finish every single sketch I made. I
          don&apos;t think this is a great idea and I want to do more sketches.
        </p>

        <p>
          Until I figure out what exactly I want to do with them they will be
          uploaded into their own Mega folder.
        </p>

        <p>
          <span className="font-medium">Important note</span>: I won&apos;t be
          uploading all sketches I&apos;ve ever made. I may delete sketches from
          this folder once they are finished, colored, etc.
        </p>

        <p>
          So if you like some of them be sure to download them because I
          can&apos;t guarantee they will stay there forever.
        </p>

        <p>
          Do you want to know when I make a sketch? Maybe share some feedback or
          ideas? If yes, then consider joining my{" "}
          <A href="https://discord.gg/NsZPUMbvMN">Discord server</A>.
        </p>
      </div>

      <div className="mt-8 text-center">
        <BrandLinkButton
          href="https://mega.nz/folder/NLQVBTyZ#nAwZOI9XwpqTq3juY-jPeg"
          className="flex-1 justify-center bg-[#d90007] text-white"
          icon={<SiMega />}
        >
          Sketches Folder
        </BrandLinkButton>
      </div>
    </div>
  );
}
